import { AccountPage } from "@common-components/account-page/account-page";
import BTButton from "@common-components/bt-button/bt-button";
import BTThemeProvider from "@common-components/bt-theme-provider";
import { Checkbox, Switch } from "@mui/material";
import { selectUserObject } from "@common-reducers/UserSelectors";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { SideBarItem } from "@common-components/sidebar/sidebar";
import { User } from "@common/models/user";
import { namespace } from "@common/config/constants";
import classes from "../account-view/account-view.module.scss";

export interface AccountNotificationsViewProps { }

export interface AccountNotificationsViewState {
  user?: User | null | undefined;
  loading: boolean;
}

const AccountNotificationsView = () => {
  const { t } = useTranslation(namespace);
  const user = useSelector(selectUserObject);
  const [desktopAllow, setDesktopAllow] = useState<boolean>();

  const accountNotificationsView = () => {
    return (
      <div className={classes.pageContainer}>
        <div className={classes.titleContainer}>
          <h4 className={classes.pageTitle}>{t('accountNotification.pageTitle')}</h4>
        </div>
        <div className={classes.accountSettingBody}>
          <div className={classes.notificationTableContainer}>
            <div
              className={
                classes.notificationTableRow +
                " " +
                classes.notificationTableRowHeader
              }
            >
              <h6>{t('accountNotification.notificationsHeader')}</h6>
              <span style={{ opacity: desktopAllow ? 1 : 0.5 }}>{t('accountNotification.desktop')}</span>
              <span>{t('accountNotification.email')}</span>
              <span>{t('accountNotification.whatsApp')}</span>
            </div>
            <div
              className={
                classes.notificationTableRow +
                " " +
                classes.notificationTableRowNoti
              }
            >
              <h6>{t('accountNotification.whenAddedToBoard')}</h6>
              <Checkbox disabled={desktopAllow ? false : true} defaultChecked />
              <Checkbox defaultChecked />
              <Checkbox defaultChecked />
            </div>
            <div
              className={
                classes.notificationTableRow +
                " " +
                classes.notificationTableRowNoti
              }
            >
              <h6>{t('accountNotification.whenAddedAsOwner')}</h6>
              <Checkbox disabled={desktopAllow ? false : true} defaultChecked />
              <Checkbox defaultChecked />
              <Checkbox defaultChecked />
            </div>
            <div
              className={
                classes.notificationTableRow +
                " " +
                classes.notificationTableRowNoti
              }
            >
              <h6>{t('accountNotification.onChatRepliesOwned')}</h6>
              <div className={classes.emptyNoDesk}></div>

              <Checkbox defaultChecked />
              <Checkbox defaultChecked />
            </div>
            <div
              className={
                classes.notificationTableRow +
                " " +
                classes.notificationTableRowNoti
              }
            >
              <h6>{t('accountNotification.onChatRepliesMember')}</h6>
              <div className={classes.emptyNoDesk}></div>
              <Checkbox defaultChecked />
              <Checkbox defaultChecked />
            </div>
            <div className={classes.DesktopAllowContainer}>
              <Switch
                onChange={(e) => {
                  if (e.target.checked) {
                    setDesktopAllow(true);
                  } else {
                    setDesktopAllow(false);
                  }
                }}
              />
              <h6>{t('accountNotification.desktopNotifications')}</h6>
            </div>
            <div style={{ justifyContent: "flex-end", display: "flex" }}>
              <BTButton
              // onClick={saveUserFields}

              >
                {t('common.saveChanges')}
              </BTButton>

            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <BTThemeProvider>
      <AccountPage
        page={accountNotificationsView()}
      ></AccountPage>
    </BTThemeProvider>
  );
};

export default AccountNotificationsView;
function UseState(): [any, any] {
  throw new Error("Function not implemented.");
}
